import React from 'react'
import {
  Attributes,
  Detail,
  Details,
  TitleGroup,
  Price,
  Location,
  Seller,
  InfoArea,
  InfoAreaColumn,
  Favorite,
  Division,
} from '@/modern/components/Card'
import AutopagoStamp from '@/modern/components/Stamps/Autopago'
import MegaFeiraoStamp from '@/modern/components/Stamps/MegaFeirao'
import BlackFeiraoStamp from '@/modern/components/Stamps/BlackFeirao'
import OfertaDestaqueStamp from '@/modern/components/Stamps/OfertaDestaque'
import ParceiroSantanderStamp from '@/modern/components/Stamps/ParceiroSantander'
import useFavorites from '@/modern/actions/useFavorites'
import CarDeliveryExtendedStamp from '@/modern/components/Stamps/ExtendedCarDelivery'
import DefineOrderSeals from '@/modern/components/VehicleCardFactory/defineOrderSeals'
import { config } from 'config/config'
import { Link, LinkWithGrow, AlignHorizontalInfoAreaStamp } from '../style'

const InfoAreaHorizontal = ({
  id,
  model,
  make,
  version,
  price,
  location,
  year,
  travelledDistance,
  seller,
  href = '#',
  attributes = [],
  stamps = {},
  canIUseParceiroSantander,
  wasFavorited,
  type,
  wasSold,
  oldAd,
}) => {
  const linkProps = !wasSold ? { rel: 'nofollow', target: '_blank', href } : {}
  const { checkIfCardWasFavorited, setFavoriteItem } = useFavorites()
  const cardWasFavoritedInStore = checkIfCardWasFavorited(id)
  const { showCarDeliveryExtendedStamp } = config

  return (
    <InfoArea isHorizontal>
      <InfoAreaColumn grow={1}>
        <LinkWithGrow {...linkProps}>
          <TitleGroup
            needsRightSpace={stamps.superPreco}
            title={`${make} ${model}`}
            subtitle={version}
            isHorizontal
          />

          <DefineOrderSeals stamps={stamps} />
        </LinkWithGrow>

        <LinkWithGrow {...linkProps}>
          <Attributes list={attributes} />
        </LinkWithGrow>

        <Details minHeight="30px" isHorizontal>
          <Detail>
            <Seller value={year} />
          </Detail>
          <Detail>
            <Seller value={travelledDistance} />
          </Detail>
        </Details>

        <Division />

        <Details minHeight="30px" isHorizontal>
          <Detail>
            <Link {...linkProps}>
              <Location value={location} isHorizontal />
            </Link>
          </Detail>
          <Detail>
            <Seller value={seller} />
            <Favorite
              onClick={() =>
                setFavoriteItem({
                  id,
                  type,
                  wasFavorited: cardWasFavoritedInStore,
                  oldAd,
                  details: { ...oldAd, Type: type },
                })
              }
              filled={wasFavorited || cardWasFavoritedInStore}
              isHorizontal
            />
          </Detail>
        </Details>
      </InfoAreaColumn>
      <InfoAreaColumn>
        <AlignHorizontalInfoAreaStamp>
          {stamps.feiroes.ofertaDestaque && <OfertaDestaqueStamp />}
          {stamps.feiroes.megaFeirao && <MegaFeiraoStamp />}

          {stamps.feiroes.blackFeirao && (
            <BlackFeiraoStamp width="119px" height="20px" />
          )}

          {stamps.autopago && <AutopagoStamp />}
          {canIUseParceiroSantander() && <ParceiroSantanderStamp />}
          {stamps.carDelivery && showCarDeliveryExtendedStamp && (
            <CarDeliveryExtendedStamp />
          )}
        </AlignHorizontalInfoAreaStamp>
        <Price isHorizontal value={price} />
      </InfoAreaColumn>
    </InfoArea>
  )
}

export default InfoAreaHorizontal
